import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DataReviewModel } from 'src/app/data-review/@shared/data-review.model';
import { fillSkeletonData } from 'src/app/@shared/app-helper';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'data-review-preview',
  standalone: false,
  styleUrls: ['./data-review-preview.component.scss'],
  templateUrl: './data-review-preview.component.html',
})
export class DataReviewPreviewComponent {
  // first/last-item css selector issue -> ensure ion item renders bottom border properly
  @Input() public nth: 'first' | 'last' | 'only' | 'default' = 'only';
  @Input() public type: 'thumbnail' | 'avatar' | 'card';

  @Output() public openDetail: EventEmitter<DataReviewModel> = new EventEmitter<DataReviewModel>();

  public showSkeleton: boolean = true;

  // fill item with skeleton data
  // !!!IMPORTANT!!! always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<DataReviewModel> = {
    editor: fillSkeletonData('title'),
    organizationName: fillSkeletonData('title'),
    organizationType: 'FORM.INPUT.TYPE.OPTIONS.SELF_HELP_ADDRESS',
    status: 'accepted',
    updatedAt: new Date().toISOString(),
  };

  @Input()
  public get item(): DataReviewModel {
    return this._item as DataReviewModel;
  }

  public set item(item: DataReviewModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<DataReviewModel>;
    this.showSkeleton = false;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get organizationDetailPath(): string | null {
    const organization = this.item?.organization;

    if (!organization?.id || !organization?.type) {
      return null;
    }

    const organizationType = organization.type;
    const organizationSubType = organization.subType || 'all';

    return `/main/organizations/${organizationType}/${organizationSubType}/detail/${organization.id}`;
  }

  public onOrganizationNameClicked(event: Event): void {
    event.stopPropagation();
  }
}
